import React from 'react';

export default function StatisticsSidebar({ stats }) {
    if (!stats) {
        return (
            <div>
                <h3>Loading Statistics...</h3>
            </div>
        );
    }

    return (
        <div>
            <h3>Arbeitszeiten:</h3>
            <p><strong>Aktuelle Woche:</strong> <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{stats.totalTimeCurrentWeek}</a></p>
            <p><strong>Letzte Woche:</strong> <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{stats.totalTimeLastWeek}</a></p>
            <p><strong>Aktueller Monat:</strong> <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{stats.totalTimeThisMonth}</a></p>
            <p><strong>Letzter Monat:</strong> <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{stats.totalTimeLastMonth}</a></p>

            <br></br>
            <h4>Projekte:</h4>
            <ul>
                {stats.projectStats.map(p => (
                    <li key={p.projectId}>
                        <b>{p.projectName}</b><br/>
                        Aktuelle Woche: <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{p.totalTimeCurrentWeek}</a><br/>
                        Letzte Woche: <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{p.totalTimeLastWeek}</a><br/>
                        Aktueller Monat: <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{p.totalTimeThisMonth}</a><br/>
                        Letzter Monat: <a style={{ color: 'var(--primary-color)', fontWeight: 'bold'}}>{p.totalTimeLastMonth}</a>
                    </li>
                ))}
            </ul>
        </div>
    );
}
